module.exports = __webpack_public_path__ + "media/images/covid/banner/sidebar/en-e501dadeaef67ab729df7b3729e93a6d.jpg";